<!-- =========================================================================================
    File Name: AgGridTable.vue
    Description: Ag Grid table
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div id="ag-grid-demo">
        <vx-card>
            <!-- TABLE ACTION ROW -->
            <div class="flex flex-wrap justify-between items-center">

                <div class="mb-5 md:mb-0 mr-5 ag-grid-table-actions-left" style="display: flex">
                    <div class="con-select select-large" style="width: auto">
                        <div class="input-select-con">
                            <select v-model="year" @change="refresh" class="input-select vs-select--input" style="padding: 8.8px;">
                                <option :key="index" :value="item" v-for="(item,index) in years">{{ item }}</option>
                            </select>
                        </div>
                    </div>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <div v-if="userInfo.type_id === 1" class="con-select select-large" style="width: auto">
                        <div class="input-select-con">
                            <select v-model="country_id" @change="refresh" class="input-select vs-select--input">
                                <option :key="index" :value="item.id" v-for="(item,index) in countries">{{ item.name }}</option>
                            </select>
                        </div>
                    </div>
                </div>

                <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
                <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
                    <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">{{ $t('ExportasCSV') }}</vs-button>
                </div>
            </div>
            <ag-grid-vue
                id="weeklyGrid"
                :gridOptions="gridOptions"
                class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="columnDefs"
                :rowData="items"
                colResizeDefault="shift"
                :animateRows="true">
            </ag-grid-vue>
        </vx-card>
    </div>
</template>

<script>
    import { AgGridVue } from "ag-grid-vue"

    import '@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss'

    export default {
        components: {
            AgGridVue,
        },
        data() {
            return {
                userInfo: window.userInfo,
                countries: [],
                country_id: 0,
                year: (new Date().getFullYear()),
                gridOptions: {},
                gridApi: null,
                columnDefs: [],
                items: [],
            }
        },
        created() {
            this.$vs.loading();
            const thisIns = this;

            if (this.userInfo.type_id === 1) {
                axios.get(apiUrl + '/countries/getList?token=' + token)
                    .then(function (response) {
                        let data = response.data;
                        if (data.code === 200) {
                            thisIns.countries = data.data;
                            thisIns.countries.unshift({
                                id: 0,
                                name: "Global"
                            });
                            //thisIns.country_id = data.data[0].id;
                            thisIns.refresh();
                        } else {
                            if (data.code === 401) {
                                window.logout();
                            }
                            thisIns.$vs.notify({
                                title: 'Error',
                                text: data.message,
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-alert-circle'
                            });
                        }
                    });
            }
            else{
                thisIns.country_id = this.userInfo.country_id;
                thisIns.refresh();
            }

        },
        methods: {
            refresh(){
                this.$vs.loading();
                const thisIns = this;
                axios.get(apiUrl+'/statistic/weekly?year='+this.year+'&country_id='+this.country_id+'&token='+token)
                    .then(function (response) {

                        let data = response.data;
                        if(data.code === 200){
                            thisIns.columnDefs = data.data.weeks;
                            thisIns.items = data.data.products;
                        }else{
                            if (data.code === 401){
                                window.logout();
                            }
                            thisIns.$vs.notify({
                                title: 'Error',
                                text:  data.message,
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-alert-circle'
                            });
                        }
                        thisIns.$vs.loading.close();
                    });
            }
        },

        computed : {
            years() {
                const year = new Date().getFullYear();
                return Array.from({length: year - 2022}, (value, index) => 2023 + index)
            }
        },
        mounted() {
            this.gridApi = this.gridOptions.api;
            this.gridApi.setDomLayout("autoHeight");
            document.querySelector("#weeklyGrid").style.height = "";
        }
    }

</script>


<style lang="scss">
    #weeklyGrid{
        height: auto;

        .ag-header-cell{
            padding-left: 10px !important;
            padding-right: 10px !important;
        }
        .ag-cell{
            padding-left: 10px !important;
            padding-right: 10px !important;
        }
    }
</style>
